import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchTags'
})
export class SearchTagsPipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    if(!items) return [];
    if(!searchText) return items;
searchText = searchText.toLowerCase();
return items.filter( it => {
      return it.tag_name.toLowerCase().includes(searchText);
    });
   }

}
